module.exports = __webpack_public_path__ + "static/media/fist-quizz.c926cb2c.jpg";